//shortcut

export * from '@lib/base/common'
export default from '@lib/base/common'
